import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const MastersPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    masterType: PropTypes.string,
    masterName: PropTypes.string,
    active: PropTypes.bool,
});

export const MastersDefaultProps = {
    _id: undefined,
    masterType: PropTypes.string,
    masterName: '',
    active: true,
};

export const MastersYupSchema = Yup.object().shape({
    masterName: Yup.string().min(2, 'Too Short!').max(70, 'Too Long!').required('Required'),
    active: Yup.bool().required('Required'),
});

export default {
    MastersDefaultProps,
    MastersPropTypes,
    MastersYupSchema,
};
